<div class="outer_div">
    <div class="square_shape">
        <img src="../../../assets/images/home_banner.jpg" alt="banner">
        <div class="in_side_images">
        </div>
    </div>
</div>

<div class="academic-writing">
    <div class="container">
        <div class="row">
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-8">
                <h1 class="main-title ">
                    <span>학술 언어, 과학, 기술, 비즈니스등</span> 모든 언어에 최적화된
                    <b>‘트링카’</b>
                </h1>
                <p>트링카(Trinka)는 문장에 알맞는 단어 추천 및 영어문법을
                    <br /> 자동으로 체크하고 수정하는 인공지능 AI 툴 입니다. </p>
                <ul class="highted-points">
                    <li>3000개 이상의 문법 검사</li>
                    <li>어조 및 스타일 개선</li>
                    <li>고급단계 글쓰기 팁</li>
                    <li>모든 학술분야에 사용 가능</li>
                </ul>
                <div class="col-md-12">
                    <div class="banner-btns">
                        <!-- no_hover -->
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">
                            <i class="fa fa-sign-in"></i> 무료 가입 </a>
                        <!-- <div class="banner-btns-inner">
                            <a href="https://cloud.trinka.ai" target="_blank">
                                <div class="icons">
                                    <img src="../../../assets/images/Get_stated_online_icons.png" alt="Online start">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text">지금 글쓰기를 시작하세요.</span>
                                    <p>Trinka Cloud에 로그인</p>
                                </div>
                            </a>
                        </div>
                        <div class="banner-btns-inner">
                            <a [routerLink]="['/wordplugin']">
                                <div class="icons">
                                    <img src="../../../assets/images/download_trinka_icon.png" alt="Download Trinka">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text">출시예정!</span>
                                    <p>무료 Microsoft Word 플러그인</p>
                                </div>
                            </a>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-4">
                <div class="technical-writing">
                    <div class="technical-writing-slider">
                        <section class="slide-wrapper">
                            <div class="hub-slider">
                                <div class="hub-slider-slides">
                                    <ul>
                                        <li>
                                            <div class="slider-card">
                                                <p>
                                                    <span>On the other hand</span>
                                                    <span class="themeColor">However</span>, additional factors
                                                    <span>which influence</span>
                                                    <span class="themeColor">influencing</span> patient prognosis and
                                                    <span>leading to a reduction in</span>
                                                    <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Apo A1 levels
                                                    <span>are</span> appeared to
                                                    <span>negatively correlate
                                                    </span>
                                                    <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with
                                                    our findings.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>This result
                                                    <span>may</span>
                                                    <span class="themeColor">may be</span>
                                                    <span>attribute</span>
                                                    <span class="themeColor">attributed to</span>
                                                    patients appendectomized for over 20 years being older than in controls.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                                    <span>transverse myelitis with long spinal cord lesions</span>
                                                    <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>The
                                                    <span>retarded children</span>
                                                    <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Utilities would continue to
                                                    <span>have the obligation</span>
                                                    <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="hub-slider-controls">
                                    <button aria-label="next" class="hub-slider-arrow hub-slider-arrow_next">
                                        <i class="fa fa-chevron-up"></i>
                                    </button>
                                    <button aria-label="previous" class="hub-slider-arrow hub-slider-arrow_prev">
                                        <i class="fa fa-chevron-down"></i>
                                    </button>
                                </div>

                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="for_mobile_contents">
    <div class="mobile_slider_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000">
                <div class="academic_writing_section main_slider_homepage">
                    <div class="container">
                        <div class="academic_slider_section">
                            <div id="main_slider" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <p>
                                            <span>On the other hand</span>
                                            <span class="themeColor">However</span>, additional factors
                                            <span>which influence</span>
                                            <span class="themeColor">influencing</span>
                                            patient prognosis and
                                            <span>leading to a reduction in</span>
                                            <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Apo A1 levels
                                            <span>are</span> appeared to
                                            <span>negatively correlate</span>
                                            <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with our findings.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>This result
                                            <span>may</span>
                                            <span class="themeColor">may be</span>
                                            <span>attribute</span>
                                            <span class="themeColor">attributed to</span>
                                            patients appendectomized for over 20 years, being older than in controls.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span>transverse myelitis with long spinal cord lesions</span>
                                            <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>The
                                            <span>retarded children</span>
                                            <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>

                                    <div class="carousel-item">
                                        <p>Utilities would continue to
                                            <span>have the obligation</span>
                                            <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                    </div>


                                    <a class="carousel-control-prev" href="#main_slider" data-slide="prev">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                    <a class="carousel-control-next" href="#main_slider" data-slide="next">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="academic_writing_section academic_background_shap">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="academic_writing_text">
                    <h2>학술 및 기술 글쓰기 맞게 설계된 트링카!</h2>
                    <p>트링카는 특히 학술 주제 분야별로 나타나는 난해한 오류도 정확하게 찾아내어
                        <br /> 복잡한 문법 오류부터 과학적 어조, 저널에 맞는 스타일까지 모두 검사합니다.</p>
                    <!-- <p>Trinka는 학술 글쓰기에 특히 나타나는 난해한 오류를 다른 어떤 툴보다 잘 찾아냅니다.<br /> 복잡한 문법 오류에서 과학적 어조와 스타일까지 Trinka는 모두 검사합니다!</p> -->
                </div>
            </div>
        </div>

        <div class="academic_slider_section">
            <div id="subject-verb-d" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>까다로운 오류까지 교정하는 트링카!</h3>
                    <p>Trinka는 특히 학술 및 기술 글쓰기에 가장 적합하도록 설계되어 있으며 3000가지 이상의 복잡한 문법 오류를 바로잡습니다. 이제 스트레스 받지 않고 오류 없는 글쓰기를 할 수
                        있습니다!
                    </p>
                    <ul class="carousel-indicators">
                        <li data-target="#subject-verb-d" data-slide-to="0" class="active">
                            <span></span> 주어-동사, 대명사-선행사 불일치
                        </li>
                        <li data-target="#subject-verb-d" data-slide-to="1">
                            <span></span>구문, 단어 선택
                        </li>
                        <li data-target="#subject-verb-d" data-slide-to="2">
                            <span></span>대명사, 관사 사용
                        </li>
                        <li data-target="#subject-verb-d" data-slide-to="3">
                            <span></span>전문 용어 철자</li>
                    </ul>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>주어-동사 불일치</h4>
                        <p>Five different experts
                            <span>was</span>
                            <span class="themeColor">were</span> asked to evaluate the individual's performance and interobserver agreement was assessed.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>구문</h4>
                        <p>Rarely
                            <span class="themeColor">do</span> we use aneurysm clips to obliterate the vessels.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>대명사, 관사 사용</h4>
                        <p>
                            <span>Every</span>
                            <span class="themeColor">Every one</span> of these studies claimed the importance of the spatial externalities for economic
                            growth.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>전문 용어 철자</h4>
                        <p>It was full of
                            <span>turgid</span>
                            <span class="themeColor">turbid</span> water and on analysis, the contamination levels were found to be very high.</p>
                    </div>
                    <a class="carousel-control-prev" href="#subject-verb-d" data-slide="prev">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#subject-verb-d" data-slide="next">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>


<div class="academic_writing_section beyond_grammer_spelling_sections footer_shap_background">
    <div class="container">

        <div class="academic_slider_section">
            <div id="spelling_grammers" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>문법과 철자 차원을 넘어 작문실력을 개선할 수 있습니다.</h3>
                    <p>Trinka는 문법뿐만 아니라, 어휘, 어조, 구문 등 많은 측면에서 글 실력을 개선합니다. Trinka를 통해 논지를 자신 있게 펼치십시오.</p>
                    <ul class="carousel-indicators">
                        <li data-target="#spelling_grammers" data-slide-to="0" class="active">
                            <i>
                                <img src="../../../assets/images/style_guides_icon.png" alt="Style guides">
                            </i>
                            스타일 가이드(APA | AMA)
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="1">
                            <i>
                                <img src="../../../assets/images/scientific_tone_icon.png" alt="Scientific tone" />
                            </i>
                            과학적 어조
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="2">
                            <i>
                                <img src="../../../assets/images/technical_word_choice_icon.png" alt="Technical word choice" />
                            </i>
                            기술적인 단어 선택
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="3">
                            <i>
                                <img src="../../../assets/images/word_count_reduction_icon.png" alt="Word count reduction" />
                            </i>
                            간결함
                        </li>
                    </ul>


                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>스타일 가이드의 선호 사항</h4>
                        <p>The
                            <span>males</span>
                            <span class="themeColor">men</span> scored higher than the
                            <span>females</span>
                            <span class="themeColor">women.</span>
                        </p>
                        <!-- <p>This system <span>is comprised of</span> <span class="themeColor">comprises</span> two
                            separate holding fixtures for the head.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>격식에 맞는 어조</h4>
                        <p>However, this method is novel and is
                            <span>very much</span>
                            <span class="themeColor">significantly</span> different from the classical method.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>기술적인 단어 선택</h4>
                        <p>The CNTs also could enhance the resistance to photo degradation by UV irradiation during
                            <span>cyclical</span>
                            <span class="themeColor">cyclic</span> ageing tests.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>간결함</h4>
                        <p>Studies
                            <span>were carried out to evaluate</span>
                            <span class="themeColor"> evaluated</span>
                            the effect of lower temperatures on energy consumption.
                        </p>
                    </div>
                    <a class="carousel-control-prev" href="#spelling_grammers" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#spelling_grammers" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>



<div class="academic_writing_section beyond_grammer_spelling_sections suggests_corrections_slider">
    <div class="container">

        <div class="academic_slider_section">
            <div id="suggests_corrections" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>분야와 관련된 교정 제안</h3>
                    <p>Trinka는 각 분야에서 가장 잘 쓰여진 논문을 학습하여 최상의 제안을
                        <br /> 함으로써 항상 명료한 글을 작성할 수 있습니다.</p>
                    <span class="top_diviedLine"></span>
                    <ul class="carousel-indicators">
                        <li data-target="#suggests_corrections" data-slide-to="0" class="active">
                            <!-- <a><img src="../../../assets/images/medicine.png" class="img-fluid" /></a>  -->
                            <i>의학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="1">
                            <!-- <a><img src="../../../assets/images/biology.png" class="img-fluid" /></a>  -->
                            <i>생물학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="2">
                            <!-- <a><img src="../../../assets/images/physics-icons.png" class="img-fluid" /></a>  -->
                            <i>물리학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="3">
                            <!-- <a><img src="../../../assets/images/social-science.png" class="img-fluid" /></a>  -->
                            <i>사회과학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="4">
                            <!-- <a><img src="../../../assets/images/engineering.png" class="img-fluid" /></a>  -->
                            <i>공학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="5">
                            <!-- <a><img src="../../../assets/images/chemistry.png" class="img-fluid" /></a>  -->
                            <i>화학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="6">
                            <!-- <a><img src="../../../assets/images/geology.png" class="img-fluid" /></a>  -->
                            <i>지질학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="7">
                            <!-- <a><img src="../../../assets/images/computer-science.png" class="img-fluid" /></a>  -->
                            <i>컴퓨터 과학</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="8">
                            <!-- <a><img src="../../../assets/images/business-and-economics.png" class="img-fluid" /></a> -->
                            <i>경제학</i>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>의학</h4>
                        <p>In general, the ADT group had a more
                            <span>advance</span>
                            <span class="themeColor">advanced</span> disease compared with the non-ADT group.
                        </p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>생물학</h4>
                        <!-- <p>A current is sent through the material; consequently polarizing the electrons are polarized.</p> -->
                        <p>The membranes were then incubated with human cleaved caspase-3 antibodies at 4°C
                            <span>for</span> overnight.</p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>물리학</h4>
                        <p>Scientists rely on exactly
                            <span>soluble</span>
                            <span class="themeColor">solvable</span>
                            problems to describe the strange effects which have quantum mechanical origin.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>사회과학</h4>
                        <p>The individual displayed
                            <span>a persistent spirit</span>
                            <span class="themeColor">persistence.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>공학</h4>
                        <p>The technique has
                            <span class="themeColor">been</span> widely used for the fabrication of SiC
                            <span>fiber</span>
                            <span class="themeColor">fibers</span> with high mechanical properties.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>화학</h4>
                        <p>A current is sent through the material, consequently
                            <span class="themeColor">polarizing</span> the electrons.
                            <span>are polarized.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>지질학</h4>
                        <p>
                            There was
                            <span class="themeColor">a</span> large tectonic movement at the end of the Mesozoic
                            <span>period</span>
                            <span class="themeColor">era</span>.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>컴퓨터 과학</h4>
                        <p>In
                            <span class="themeColor">the</span> testing phase,
                            <span>it's</span>
                            <span class="themeColor">its</span> label is determined using the
                            <span>triaining</span>
                            <span class="themeColor">training</span> instances mapped to a specific neuron.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>경제학</h4>
                        <p>The role expected
                            <span>to</span>
                            <span class="themeColor">of</span> IASB has changed when it became a member of the Financial Stability Board in 2009.</p>
                    </div>

                    <a class="carousel-control-prev" href="#suggests_corrections" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#suggests_corrections" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="purple-bg1 footer_shap_background">
    <div class="purple_background_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3 style="max-width: 100%;">트링카는 최첨단 기능을 제공합니다</h3>
                    <div class="box_text_content">
                        <p>트링카는 학술 및 기술 작성에 적합하도록 설계되어 있으며 숙련된 에디터와 언어 전문가의 전문지식을 활용하여 언어를 개선합니다.</p>
                    </div>
                    <a style="margin-top: 33px;" [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" routerLinkActive="active" class="white-btn">보고서 다운로드</a>
                </div>
            </div>
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3>Trinka는 연구기관과 기업에게 훌륭한 프로그램입니다.</h3>
                    <div class="box_text_content">
                        <p>Trinka를 사용하여 글쓰기 수준을 높이고 매력적인 가격과 기타
                            <br /> 혜택을 함께 누려보세요.</p>
                        <a [routerLink]="['/enterprise']">자세히 알아보기
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve">
                                <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                   C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                   c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"
                                />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div class="contact-sales">
                        <button type="submit" id="contactSaleButton" data-toggle="modal" data-target="#EnterPriseContactPopup"
                            class="btn btn-primary mb-2">고객센터 </button>
                        <!-- <form class="form-inline" id="contact-sales" [formGroup]="contactToSalesForm"
                            (ngSubmit)="contactToSales()">
                            <div class="form-group"
                            [ngClass]="(!contactToSalesForm.get('saleFormemail').valid && contactToSalesForm.get('saleFormemail').dirty) || (contactToSalesForm.get('saleFormemail').touched && contactToSalesForm.get('saleFormemail').pristine) ? 'TextFiledError' : ''  ">
                                <input type="email" class="form-control" id="email-add" formControlName="saleFormemail"
                                    placeholder="이메일 주소를 입력하세요" name="email">
                                <div class="error_msg_section"
                                    *ngIf="(!contactToSalesForm.get('saleFormemail').valid && contactToSalesForm.get('saleFormemail').dirty) || (contactToSalesForm.get('saleFormemail').touched && contactToSalesForm.get('saleFormemail').pristine)">
                                    <p>이메일은 필수 사항입니다.</p>
                                </div>
                                <mat-form-field appearance="outline">
                                    <mat-label>이메일 주소를 입력하세요</mat-label>
                                    <input matInput placeholder="" formControlName="saleFormemail"
                                        class="form-control">
                                </mat-form-field>
                            </div>
                            <button type="submit" class="btn btn-primary mb-2">문의하기 </button>
                        </form> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center testi">
                <h2 class="sub-head">고객 사용 후기 </h2>
                <!-- <p>Trinka 고객의 추천을 들어보십시오. </p> -->
                <!-- <p>고객 사용 후기</p> -->
            </div>
        </div>
    </div>
</div>

<div class="testimonial text-center">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="testimonial-wrap">
                    <!-- <div class="testimonal-icon">
                        <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                    </div> -->
                    <div class="testimonial-slider">
                        <div id="testi" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#testi" data-slide-to="0" class="active"></li>
                                <li data-target="#testi" data-slide-to="1"></li>
                                <li data-target="#testi" data-slide-to="2"></li>
                                <li data-target="#testi" data-slide-to="3"></li>
                                <li data-target="#testi" data-slide-to="4"></li>
                                <li data-target="#testi" data-slide-to="5"></li>
                                <li data-target="#testi" data-slide-to="6"></li>
                                <li data-target="#testi" data-slide-to="7"></li>
                                <li data-target="#testi" data-slide-to="8"></li>
                                <li data-target="#testi" data-slide-to="9"></li>
                                <li data-target="#testi" data-slide-to="10"></li>
                                <li data-target="#testi" data-slide-to="11"></li>
                                <li data-target="#testi" data-slide-to="12"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">이전에 경험할 수 없었던 영문법 교정 AI 툴이네요. 특히 중요한 문법 규칙과 단어 수까지 감수해 줘서 많은 도움을 받았습니다.
                                                </p>
                                                <p class="authorNameText">제임스 스미스</p>
                                                <span class="authorDesignationText">학술 에디터, 미국</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">영어가 모국어가 아닌 저자들이 올바른 영어 문법과 문체로 글을 쓰는 것은 쉬운 일이 아닙니다. 때때로 저자들은 외부의 도움이 없이,
                                                    그리고 더 나아가 학문적인 글에서 작은 실수조차 발견하기 어려울 수 있습니다. 자동보정 툴로 트링카 AI를 사용해봤는데, 제안된
                                                    수정사항과 피드백에 상당히 만족했습니다. 피드백을 통해 제안된 변경사항을 자세하고 간편하게 알려줘서 좋습니다.</p>
                                                <p class="authorNameText">로사 디아즈 산도발</p>
                                                <span class="authorDesignationText">물리학 및 수학 박사, 멕시코</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">저는 주로 국내외 생물의학저널에 기고하는 과학원고의 언어, 문법, 구문 개선을 위해 트링카를 사용해 왔습니다. 인터페이스가 사용자
                                                    친화적이고 사용방법이 간단해서 매우 효율적이고 번거롭지 않아 좋습니다. 논문을 편집할 수 있는 여러 가지 옵션을 필요에 따라
                                                    사용하면서, 제가 어떤 부분에 집중해야 하는지 결정할 수 있어 아주 좋습니다. 자동 수정은 논문 작성에 큰 도움이 되고, 수정
                                                    요약을 한눈에 볼 수 있는 요약 페이지는 훌륭한 아이디어네요. </p>
                                                <p class="authorNameText">파룩 라토어 박사</p>
                                                <span class="authorDesignationText">조교수 및 학과장, 파키스탄</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka.ai는 문법과 맞춤법 수정을 위해 제가 가장 유용하게 사용하고 있는 도구입니다. 애플리케이션이 최적화 되어있어 잘 작동하고
                                                    빠르고 깔끔합니다! 대만족!</p>
                                                <p class="authorNameText">밀레나 게오르기예바</p>
                                                <span class="authorDesignationText">연구원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">타제품에서 검사했던 문서를 다시 트링카에서 재확인했는데, 타제품보다 더 정확한 문법 체크를 하는 것 같아요. 놀랍네요!</p>
                                                <p class="authorNameText">디네시 굽타</p>
                                                <span class="authorDesignationText">방사선사, 인도</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">저는 트링카를 테스트 해봤고, 훌륭한 기능에 감명받았습니다. 기존에 사용하던 문법 검사툴보다 더 좋은것 같다는 느낌을 받았습니다.
                                                    같은 연구실 동료들에게 트링카를 사용하라고 적극
                                                    <br>추천했고, 트링카가 학계에서 널리 사용되기를 바랍니다.</p>
                                                <p class="authorNameText">에디스 데이비스</p>
                                                <span class="authorDesignationText">박사학위자, 영국</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">트링카 AI가 제안한 수정사항과 피드백은 놀라울 정도로 유용합니다 . 사용이 간편하고 아주
                                                    <br>편리합니다.</p>
                                                <p class="authorNameText">누르 알 리시</p>
                                                <span class="authorDesignationText">화학자, 사우디 아라비아</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">트링카를 사용한 것은 정말 좋은 경험이었고, 트링카를 사용하지 않고는 어떤 논문도 제출할 수 없습니다. 요약하자면, 트링카는 저의
                                                    생명을 구했어요!</p>
                                                <p class="authorNameText">은와지 주드</p>
                                                <span class="authorDesignationText">연구원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">저는 트링카를 수정한 문서들의 최종 체크 도구로 아주 유용하게 사용하고 있습니다. 기본 수정 중에 발생하는 오류들을 쉽고 빠르게 찾는
                                                    데 큰 도움이 됩니다. 플랫폼이 정말 마음에 드네요.
                                                </p>
                                                <p class="authorNameText">스텀프 커티스</p>
                                                <span class="authorDesignationText">연구원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">저는 Trinka.ai이 특히 에디터/출판계 에디터/ 저널 에디터들에게 매우 흥미롭고 유용한 도구라고 생각합니다. 플랫폼에서 수정
                                                    작업을 실시간으로 빠르게 확인 할 수 있다는 점이 매우 유용했습니다.</p>
                                                <p class="authorNameText">개러스 다이크</p>
                                                <span class="authorDesignationText">연구원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">저는 트랑카를 사용하고 나서 전체적인 결과물에 만족합니다. 오랫동안 그래멀리를 사용해 왔지만, 학문적 글쓰기나 기술적인 글쓰기에 있어서는
                                                    트링카가 훨씬 더 나은 선택인것 같습니다. 학술 논문 설정과 자동 파일 수정 기능이 아주 편리하고 유용합니다.</p>
                                                <p class="authorNameText">바르가바 샤르마</p>
                                                <span class="authorDesignationText">전염병학자, India</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">트링카는 문법 교정을 위한 저만의 도구입니다. 인공지능을 기반으로 언어 교정과 언어 향상은 글쓰기를 훨씬 더 쉽게 만들어줍니다. 문법적으로
                                                    오류가 없는 문서를 작성하는 것에 노력하는 시간을 줄일 수 있었고, 덕분에 연구에 더 집중할 수 있게 되었습니다.</p>
                                                <p class="authorNameText">랄프 베일리</p>
                                                <span class="authorDesignationText">신경과 의사, USA</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="users">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">AMA 스타일 가이드에 근거한 문법 수정과 제안이 정말 인상적입니다! 트링카는 의학적인 글쓰기를 위한 최고의 문법 교정 도구입니다.
                                                </p>
                                                <p class="authorNameText">토마스 안드레스</p>
                                                <span class="authorDesignationText">심장전문의, Brazil</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </a>
                        <a class="carousel-control-next" href="#testi" data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="client_rating_logo">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3">
                <div class="client_rating_text">
                    <h2>전 세계 사용자 평점</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="client_logo_right">
                    <div class="row">
                        <div class="col-md-3 col-6">
                            <div class="client-rating sourceforge">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/SourceForge_logo.png" alt="SourceForge" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustpilot">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trustpilot-1.png" alt="trustpilot" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star"></i></li>
                                </ul>
                                <p>4 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating product-hunt">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/product-hunt.png" alt="product hunt" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating g2">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/G2_Crowd.png" alt="G2" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating capterra">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/capterra-inc.png" alt="capterra" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating chrome-tool">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/chrome.png" alt="chrome" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>4.3 out of 5</p>
                            </div>
                        </div>
                        
                        
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustradius">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trust-radius.png" alt="trust-radius" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>8.4 out of 10</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating software-suggest">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/softwaresuggest-social.png" alt="software-suggest" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<app-enterprise-modal></app-enterprise-modal>